import { Link } from "@/i18n/Link";
import { ArrowRight } from "lucide-react";
import { PageLayout } from "@/components/site/PageLayout";
import { Seo } from "@/components/site/Seo";
import { useCopy } from "@/i18n/LocaleContext";

const COPY = {
  en: {
    seoTitle: "Page Not Found",
    seoDescription: "That page wasn't found on Axle Inc. Try one of these helpful links instead.",
    subheading: "404",
    heading: "Lost a wheel.",
    body: "We can't find that page. It may have moved when we rebuilt the site. Try one of these instead - or call the shop and we'll point you in the right direction.",
    links: [
      { to: "/products/", label: "All products" },
      { to: "/services/axle-repair/", label: "Service & repair" },
      { to: "/dexter/", label: "Dexter distributor info" },
      { to: "/blog/", label: "Blog" },
      { to: "/contact/", label: "Contact us" },
    ],
  },
  es: {
    seoTitle: "Página no encontrada",
    seoDescription: "No pudimos encontrar esa página en Axle Inc. Intente utilizar uno de estos enlaces útiles.",
    subheading: "404",
    heading: "Perdió una rueda.",
    body: "No podemos encontrar esa página. Es posible que se haya movido cuando reconstruimos el sitio. Intente con uno de estos enlaces en su lugar, o llame al taller y le indicaremos la dirección correcta.",
    links: [
      { to: "/products/", label: "Todos los productos" },
      { to: "/services/axle-repair/", label: "Servicio y reparación" },
      { to: "/dexter/", label: "Información del distribuidor Dexter" },
      { to: "/blog/", label: "Blog" },
      { to: "/contact/", label: "Contáctenos" },
    ],
  },
};

export default function NotFound() {
  const t = useCopy(COPY);

  return (
    <PageLayout>
      <Seo
        title={t.seoTitle}
        description={t.seoDescription}
        path="/404"
        noindex
      />
      <section className="container mx-auto px-4 py-24 md:py-32 max-w-2xl text-center">
        <p className="text-xs uppercase tracking-[0.22em] text-primary-strong font-semibold mb-4">{t.subheading}</p>
        <h1 className="text-4xl md:text-5xl font-bold tracking-tight mb-4">{t.heading}</h1>
        <p className="text-lg text-muted-foreground leading-relaxed mb-10">
          {t.body}
        </p>
        <ul className="grid gap-3 sm:grid-cols-2 text-left max-w-md mx-auto">
          {t.links.map((l) => (
            <li key={l.to}>
              <Link
                to={l.to}
                className="group flex items-center justify-between p-4 border border-border rounded-md bg-card hover:border-primary hover:shadow-sm transition-all"
              >
                <span className="font-medium">{l.label}</span>
                <ArrowRight className="h-4 w-4 text-muted-foreground group-hover:text-primary group-hover:translate-x-0.5 transition-all" />
              </Link>
            </li>
          ))}
        </ul>
      </section>
    </PageLayout>
  );
}
